// Shared accent colour for the explorer vizzes (bars, histogram, date area, donut base).
export const VIOLET = '#8B5CF6';
